var exports = {
  "rf": "VoiceMessageComposerModal.module__body___TDZrU0",
  "BK": "VoiceMessageComposerModal.module__helpText___TDZrU0",
  "kc": "VoiceMessageComposerModal.module__errorText___TDZrU0",
  "mI": "VoiceMessageComposerModal.module__meta___TDZrU0",
  "sG": "VoiceMessageComposerModal.module__recordingStatus___TDZrU0",
  "ne": "VoiceMessageComposerModal.module__controls___TDZrU0",
  "hZ": "VoiceMessageComposerModal.module__buttonInner___TDZrU0",
};

module.exports = exports;
